module.exports = __webpack_public_path__ + "static/media/pic2.a8cb9aa9.jpg";